/* global ga */
import React                            from 'react';
import PropTypes                        from 'prop-types';
import ReloadHelper                     from '../../utils/ReloadHelper';
import TeaserHelper                     from '../../utils/TeaserHelper';
import Flux                             from '../../flux/Flux';
import {renderNode}                     from 'vxteaser';
import VXBalance                        from './components/VXBalance';
import {generateKey}                    from '../../utils/CommonUtils';
import withSuspense                     from '../HigherOrderComponents/Utility/withSuspense';
import {Constants as VXTeaserConstants} from 'vxteaser';
import VXTeaserFeedback                 from './VXTeaserFeedback.js';
import withFeatureFeedback              from '../FeatureFeedback/withFeatureFeedback.js';

const Halloween = React.lazy(() => import('./components/Halloween'));
export default class ActionProvider extends React.PureComponent {

	static renderCustomNode({...args}) {
		const name = args.name.toLowerCase();

		switch (name) {
			case 'vxbalance':
				return <VXBalance />;
			case 'halloween':
				return withSuspense(<Halloween />);
			default:
				return renderNode(args);
		}
	}

    static renderHooks({type, config}) {
        switch(type) {
            case VXTeaserConstants.HookType.RenderBottomRight:
                const Wrapper = withFeatureFeedback(VXTeaserFeedback);
                return <Wrapper teaserId={config.id}></Wrapper>;
            default: return null;
        }
    }

	/**
	 *
	 * @param {string} link
	 * @returns {*}
	 */
	static getParsedActionData(link) {
		let result, arr;

		if ((arr = link.match(/^(.+)::(.*)/))) {
			result          = {};
			result.type     = arr[1];
			result.params   = {};
			result.getParam = (key) => typeof result.params[key] !== 'undefined' ? result.params[key] : undefined;

			if (typeof arr[2] === 'string') {
				const paramPairs = arr[2].split(';');
				for (const par in paramPairs) {
					const pair    = paramPairs[par].split('=');
					const subPair = pair[0].split('.');
					// is key a serialized array key?
					if (subPair.length > 1) {
						result.params[subPair[0]]             = result.params[subPair[0]] || {};
						result.params[subPair[0]][subPair[1]] = pair[1];
					} else {
						result.params[pair[0]] = pair[1];
					}
				}
			}
		}

		return result;
	}

	constructor(props) {
		super(props);

		// bind
		this.onClick = this.onClick.bind(this);
	}

	/**
	 *
	 * @param {ClickEvent} clickEvent
	 */
	onClick(clickEvent) {
		const link   = clickEvent.options.link;
		const id     = clickEvent.config && clickEvent.config.id ? clickEvent.config.id : null;
		const origin = clickEvent.origin && clickEvent.origin.constructor ? clickEvent.origin.constructor.name : 'Banner';

		if (window.ga) {
			ga('send', 'event', 'Teaser', 'click_' + origin, 'Banner:' + id);
		}

		if (link) {
			// is it a teaser link action?
			const actionData = ActionProvider.getParsedActionData(link);
			let texts;

			if (actionData) {
				switch (actionData.type) {
					case Flux.Constants.Teaser.AVS:
						TeaserHelper.callAction({
							type: Flux.Constants.ActionTypes.Teaser.OPEN_AVS,
						});
						break;
					case Flux.Constants.Teaser.PAYMENT:
						texts = actionData.getParam('texts');

						if (!texts) {
							texts = {
								'BonusTextCustom': actionData.getParam('signupText'),
							};
						}

						TeaserHelper.callAction({
							type:    Flux.Constants.ActionTypes.Teaser.OPEN_PAYTOUR,
							options: {
								option: actionData.getParam('option'),
								texts,
								signupBackground: actionData.getParam('signupBackground'),
							},
						});
						break;
					case Flux.Constants.Teaser.PROMOCODE:
						texts = actionData.getParam('texts');

						if (!texts) {
							texts = {
								'BonusTextCustom': actionData.getParam('signupText'),
							};
						}

						TeaserHelper.callAction({
							type:    Flux.Constants.ActionTypes.Teaser.OPEN_PROMOCODE,
							options: {
								pc:               actionData.getParam('pc'),
								texts,
								signupBackground: actionData.getParam('signupBackground'),
							},
						});
						break;
					case Flux.Constants.Teaser.VOICECALL:
						TeaserHelper.callAction({
							type: Flux.Constants.ActionTypes.Teaser.OPEN_VOICECALL,
						});
						break;
					case Flux.Constants.Teaser.SIGNUP:
						texts = actionData.getParam('texts');

						if (!texts) {
							texts = {
								'BonusTextCustom': actionData.getParam('signupText'),
							};
						}

						TeaserHelper.callAction({
							type:    Flux.Constants.ActionTypes.Teaser.OPEN_SIGNUP,
							options: {
								pc:               actionData.getParam('pc'),
								texts,
								signupBackground: actionData.getParam('signupBackground'),
							},
						});
						break;
					case Flux.Constants.Teaser.VIDEO:
						const videoUrl = actionData.getParam('src');

						if (videoUrl) {
							TeaserHelper.callAction({
								type:    Flux.Constants.ActionTypes.Teaser.OPEN_VIDEO,
								options: {
									container: this.refContainer,
									src:       videoUrl,
								},
							});
						}
						break;
					case Flux.Constants.Teaser.MODALBOX:
						const id = actionData.getParam('id');
						TeaserHelper.callAction({
							type:    Flux.Constants.ActionTypes.Teaser.OPEN_MODALBOX,
							options: {
								id,
							},
						}
						);
						break;
					default:
				}
			} else {
				// relative link
				if (link.match(/^\//)) {
					ReloadHelper.reload(link);
				} else if (window.location.hostname && link.indexOf(window.location.hostname.split('.').slice(-2).join('.')) === -1) {
					// external url in new window
					window.open(link);
				} else {
					window.location.href = link;
				}
			}
		}
	}

	render() {
		const childrenWithProps = React.Children.map(this.props.children,
			(child, index) => React.cloneElement(child, {
				onClickFn: this.onClick,
				key: generateKey('vxteaser', index),
			})
		);
		const getRef            = (ref) => {
			if (ref) {
				this.refContainer = ref;
			}
		};

		return (
			<div className="vxteaser-action-provider h-pos-relative">
				{childrenWithProps}
				<div ref={getRef} />
			</div>
		);
	}
}

ActionProvider.propTypes = {
	children: PropTypes.node,
};
